import { Link, Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { CustomButton } from "./CustomButton";
import googlePlayImage from "src/assets/images/wetez_google_play.png";
import arrowIcon from "src/assets/images/icon_arrow_right.svg";

export const WalletIntro = () => {
  return (
    <Box pt="115px" pl="125px" pb="185px" position="relative">
      <Typography
        variant="bold"
        fontSize="40px"
        color="white"
        alignSelf="flex-start"
        lineHeight="40px"
      >
        Wetez Wallet
      </Typography>

      <Typography color="secondary" fontSize="22px" lineHeight="22px" mt="28px">
        A Staking Wallet that can generate rewards.
      </Typography>

      <Box
        mt="64px"
        mb="70px"
        sx={{
          backgroundColor: "#F59C53",
          height: "7px",
          width: "266px",
          borderRadius: "4px",
        }}
      />

      <CustomButton
        fontSize="20px"
        padding="12px 32px"
        onClick={() => {
          window.location.href = "/wallet#supportTokens";
        }}
      >
        Explore
      </CustomButton>

      <Stack direction="row" mt="18px" alignItems="center">
        <Box width="7px">
          <img src={arrowIcon} width="100%" alt="icon" />
        </Box>

        <Typography color="secondary" fontSize="20px" ml="8px">
          Download android
        </Typography>

        <Link
          target="_blank"
          href="https://package.wetez.io/wetez-release.apk"
          underline="none"
          mx="4px"
        >
          <Typography variant="bold" fontSize="20px" color="primary">
            APK
          </Typography>
        </Link>

        <Typography color="secondary" fontSize="20px">
          directly
        </Typography>
      </Stack>

      <Box position="absolute" top="95px" right="190px">
        <img src={googlePlayImage} width="220px" height="438px" alt="intro" />
      </Box>
    </Box>
  );
};
